import { render, staticRenderFns } from "./allSim.vue?vue&type=template&id=0b01c49b&scoped=true&"
import script from "./allSim.vue?vue&type=script&lang=js&"
export * from "./allSim.vue?vue&type=script&lang=js&"
import style0 from "./allSim.vue?vue&type=style&index=0&lang=css&"
import style1 from "./allSim.vue?vue&type=style&index=1&id=0b01c49b&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b01c49b",
  null
  
)

export default component.exports